import { render, staticRenderFns } from "./UnsavedSummaryBanner.vue?vue&type=template&id=f46e776c&scoped=true&"
import script from "./UnsavedSummaryBanner.vue?vue&type=script&lang=js&"
export * from "./UnsavedSummaryBanner.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedSummaryBanner.vue?vue&type=style&index=0&id=f46e776c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46e776c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VIcon,VSpacer})
